import { SET_COUNTRIES, SET_CURRENT_LICENSEE, SET_SUBSCRIBER_LICENSEES, SET_SUBSCRIBER_LICENSE_ID } from './actions';

const INITIAL_LICENSEE_STATE = null;
const INITIAL_LICENSEE_ID_STATE = null;

export const licenseeReducer = (state = INITIAL_LICENSEE_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_LICENSEES: {
               return action.payload;
          }

          default:
               return state;
     }
};

export const currentLicenseeReducer = (state = INITIAL_LICENSEE_STATE, action) => {
     switch (action.type) {
          case SET_CURRENT_LICENSEE: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const licenseeIdReducer = (state = INITIAL_LICENSEE_ID_STATE, action) => {
     switch (action.type) {
          case SET_SUBSCRIBER_LICENSE_ID: {
               return action.payload;
          }
          default:
               return state;
     }
};

export const countriesReducer = (state = [], action) => {
     switch (action.type) {
          case SET_COUNTRIES: {
               return action.payload;
          }
          default:
               return state;
     }
};
